export default {
  overWriteShowCreditUpcs: ['UP-91171564-50'],
};
